export default __webpack_public_path__ + "static/media/sanity.74928b15.svg";